import * as RadixDropdown from '@radix-ui/react-dropdown-menu'
import { ComponentProps, FC, PropsWithChildren } from 'react'
import { DropdownContext } from './DropdownContext'
import { useDropdown } from './hooks'
import { DropdownProps } from './types'

/**
 * Exports the Dropdown component and DropdownItem to be grouped within.
 * The component can be controlled by using the isOpen and onOpenChange props.
 */

export const Dropdown: FC<
  PropsWithChildren<DropdownProps & ComponentProps<typeof RadixDropdown.Root>>
> = (props) => {
  const dropdown = useDropdown(props)

  return (
    <DropdownContext.Provider value={{ ...dropdown, isDarkMode: props.dark }}>
      <RadixDropdown.Root open={dropdown.isOpen} onOpenChange={dropdown.onOpenChange} {...props}>
        {props.children}
      </RadixDropdown.Root>
    </DropdownContext.Provider>
  )
}
